export default function CollectionIcon({ className="", onClick=null }) {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
    >
      <path d="M387.01,78.14H112.99c-24.45,0-44.27,19.82-44.27,44.27v185.1c0,24.45,19.82,44.27,44.27,44.27h81.52l57.2,69.54c.38.46.86.53,1.12.53s.75-.07,1.13-.53l57.19-69.54h75.87c24.45,0,44.26-19.82,44.26-44.26V122.41c0-24.45-19.82-44.27-44.27-44.27ZM380.05,325.52h-81.31l-45.91,55.81-45.91-55.81h-90.31c-11.94,0-21.61-9.68-21.61-21.61v-172.8c0-14.74,11.95-26.7,26.7-26.7h260.48c12.6,0,22.82,10.22,22.82,22.82v173.34c0,13.78-11.17,24.95-24.95,24.95Z"/>
    </svg>
  );
}
